import React, {useState} from 'react'
import { Button, Accordion, InfoCard } from '../../../components'
import { CaretRight } from '@phosphor-icons/react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopySimple, Circle, RadioButton, Info } from '@phosphor-icons/react';

const getAttendeeResponse = (questionConfig, id, value) => {
  if (Array.isArray(value)) {
    const options = questionConfig?.options?.reduce((obj, opt) => {
      return {
        ...obj,
        [opt?.id]: opt?.value,
      };
    }, {});

    if (value?.includes('internal-tmt-others')) {
      return value.map((val) => options?.[val]).concat(value[value.length - 1]).filter((item) => !!item).join(', ');
    }

    return value.map((val) => options?.[val]).filter((item) => !!item).join(', ');
  }

  if (questionConfig?.options?.length && questionConfig?.type !== 'Email') {
    return questionConfig.options.find((item) => item?.id === value)?.value;
  }

  return value;
};

const Accordions = ({ isCancelled, paymentDetails, questionsMap, bookingDetails, ticketDescription, refundInfo, ticketStatus, ticketCategory }) => {
  const [copied, setCopied] = useState(false);
  const termsUrl='https://takemytickets.co.in/terms-and-conditions';
  const accTitle = <div className='label-14 px-5 py-2'>Ticket description</div>

  function formatAmountIndian(amountStr) {
    const amountNum = parseFloat(amountStr);

    return amountNum.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function formatDate(unixSeconds) {
    const timestampMs = unixSeconds * 1000; // Convert to milliseconds
    const date = new Date(timestampMs);
  
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
  
    return date.toLocaleString('en-US', options);
  }

  const accContent = 
    <div className='text-black px-5 pt-1 pb-2 flex flex-col gap-4'>
      <div className='px-3 py-1 bg-light rounded-full w-fit heading-12 text-primary'>{ticketCategory}</div>
      <div className='text-12'>{ticketDescription}</div>
    </div>

  const paymentTitle = <div className='label-14 px-5 py-3'>Payment details</div>
  const paymentContent = paymentDetails && (
    <div className='flex flex-col gap-3 px-5 py-2'>

      {paymentDetails.map((item, index) => (
        <div key={index} className='flex justify-between'>
          <div className='text-grey-70 text-12'>{item.name}</div>
          <div className='text-black label-14'>₹ {item.amount}</div>
        </div>
      ))}
      <div className='flex justify-between pb-4 border-b border-grey-70'>
        <div className='text-grey-70 text-12'>Total Paid</div>
        <div className='text-black label-14'>₹ {paymentDetails.reduce((total, item) => total + item.amount, 0)}</div>
      </div>
      {refundInfo?.refund_properties?.status ===  'initiated' && (
        <>
        <div className='bg-[#E5FFF6] text-primary-green px-2 py-1 rounded-2xl label-12 items-center w-fit'>Refund Initiated</div>
        <div className='label-12 text-grey-70 px-2 py-1'>We’ll refund you the money within 2-7 business days.</div>
        </>
      )}
       {refundInfo?.refund_properties?.status ===  'succeeded' && (
        <div className='bg-[#E5FFF6] text-primary-green px-2 py-1 rounded-2xl text-12 items-center w-fit'>Refund Initiated</div>
      )}
    </div>
  );

  const handleCopy = (link) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };


  const refundTitle =
  <div className='label-14 px-5 py-2'>
  <div className="flex items-center justify-between gap-5">
    <div>Refund Status</div>
    <div className="bg-[#E5FFF6] text-primary-green px-2 py-1 rounded-2xl text-12 flex items-center w-fit">
     {refundInfo?.data?.refund_properties?.status === 'initiated' && 'REFUND INITIATED'}
     {refundInfo?.data?.refund_properties?.status === 'succeeded' && 'REFUND COMPLETED'}
    </div>
  </div>
</div>

  const refundContent = 
  <div className="flex flex-col gap-2 px-5 py-2">
  
  {/* ARC ID section */}
  <div className="label-14 flex items-center gap-1">
    ARN ID: 
    <span className="text-14 text-grey-70">{refundInfo?.data?.refund_properties?.network_reference_number}</span>
    <span>
      <CopyToClipboard onCopy={() => handleCopy(`${refundInfo?.data?.refund_properties?.network_reference_number}`)} text={refundInfo?.data?.refund_properties?.network_reference_number}>
        <CopySimple
          size={20}
          color={copied ? "grey" : "black"}
          className="cursor-pointer"
        />
      </CopyToClipboard>
    </span>
  </div>

  {/* Refund Timeline */}
  <div className="flex flex-col gap-2 mt-2">
  
    <div className="flex items-center gap-2 px-3 py-2 rounded-md">
      {refundInfo?.data?.refund_properties?.status === 'initiated' && <Circle size={24} color="#cacaca" weight="fill" />}
      {refundInfo?.data?.refund_properties?.status === 'succeeded' && <RadioButton size={32} color="#23ab37" weight="fill" />}
      <div className="flex flex-col">
        <div className="font-semibold text-14">Refund Initiated for ₹{formatAmountIndian(refundInfo?.data?.refund_properties?.amount)}</div>
        {refundInfo?.data?.refund_properties?.status !== 'succeeded' && <div className="text-12 text-grey-70">{formatDate(refundInfo?.data?.refund_properties?.date)}</div>}
      </div>
    </div>

 {refundInfo?.data?.refund_properties?.status === 'succeeded' &&
    <div className="flex items-center gap-2 px-3 py-2 rounded-md">
      <RadioButton size={32} color="#23ab37" weight="fill" />
      <div className="flex flex-col">
        <div className="font-semibold text-14">Refund Completed</div>
        <div className="text-12 text-grey-70">{formatDate(refundInfo?.data?.refund_properties?.date)}</div>
      </div>
    </div>
   }

   <InfoCard
    content={<p>Share <span className = "font-bold">ARN ID</span> with your bank to track your refund. If it isn’t in your account within 5 business days, please check with your bank.</p>}
    icon={<Info weight="fill"
      size={32} />}
    />

  </div>

</div>



  const bookingTitle = <div className='label-14 px-5 py-2'>Booking details</div>
  const bookingContent = bookingDetails && bookingDetails.map((attendee, index) => (
    <div key={index} className='flex flex-col px-5 py-2 gap-6 border-b border-grey-10 pb-7'>
      <div className='flex gap-5'>
        <img src={attendee.image || 'assets/images/nolist.png'} className='flex w-10 h-10 rounded-full'/>
        <div className='flex flex-col gap-2'>
          <div className='text-black label-14'>Attendee {index + 1} - {attendee.full_name}</div>
          {index === 0 && (<div className='flex text-12 rounded-md bg-light text-primary p-2 w-fit'>Purchased tickets</div>)}
        </div>
      </div>
      {/* <div className='grid grid-flow-col justify-stretch'>
        <div className='flex label-14 flex-col gap-2'>
          <div>Phone number</div>
          <div className='text-black'>{attendee.phone_number}</div>
        </div>
      </div> */}
      {Object.keys(attendee).filter((item) => item !== 'full_name').map((key, i) => questionsMap?.[key]?.label ? (
        <div key={i} className='flex flex-col gap-2'>
          <div className='label-14 text-grey-70'>{questionsMap?.[key]?.label}</div>
          <div className='label-14 text-black'>{getAttendeeResponse(questionsMap?.[key], key, attendee?.[key])}</div>
        </div>
      ) : null)}
    </div>
  ))

  const handleClick = () => {
    const phoneNumber = '9025082101';
    const desktopUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}`;
    const mobileUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    const isMobile = window.innerWidth < 650;

    window.open(isMobile ? mobileUrl : desktopUrl, '_blank');
  };

  return (
    <div>
      <div className='flex flex-col gap-4 py-2 items-center'>
        {refundInfo && <Accordion className='bg-white w-full rounded-xl' title = {refundTitle} content = {refundContent}/>}
        <Accordion className='bg-white w-full rounded-xl' title={accTitle} content={accContent} />
          {/* <Accordion className='bg-white w-full rounded-xl' title={paymentTitle} content={paymentContent} /> */}
        
        {!isCancelled && (
          <Accordion className='bg-white w-full rounded-xl' title={bookingTitle} content={bookingContent} />
        )}
        <div className='bg-white px-5 py-4 pr-2.5 w-full flex justify-between rounded-2xl items-center cursor-pointer'
          onClick={handleClick}
        >
          <div className='flex gap-2'>
            <p className='label-14'>Get in Touch</p>
            <img src="/assets/images/wp.svg" alt="whatsapp" className="w-[20] h-[20px]"/>
          </div>
          <CaretRight size={16}/>
        </div>
        {/* <Button
          type="primary-black"    
          onClick={handleClick} 
          className="w-fit"
          iconRight={<img
            src="/assets/images/wp.svg"
            alt="whatsapp"
            className="w-[32px] h-[32px]"
          />}
        >
         Get in Touch
        </Button> */}
      </div>
    </div>
  )
}

export default Accordions
